module.exports = __webpack_public_path__ + "img/fi-roundup.2ddf01bf.jpg";